export enum NotepadTab {
  Comments,
  Preview
}
